import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from "../../../lib/utils";
import useSettings from "../../hooks/useSettings";
import SobaVerticalNavExpansionPanel from './SobaVerticalNavExpansionPanel';
import { authRoles } from '../../auth/authRoles';
import LucideIcon from '../LucideIcon';

const SobaVerticalNav = ({ items }) => {
	const { settings } = useSettings();
	const { mode } = settings.layout1Settings.leftSidebar;
	const authenticatedPartner = JSON.parse(localStorage.getItem("authenticatedPartner"));

	const renderLevels = (data) => {
		if (!data) return null;
		
		return data.map((item, index) => {
			if (item.type === 'label')
				return (
					<p key={index} className={cn(
						"text-[12px] mt-5 ml-[15px] mb-[10px] uppercase text-white/50",
						mode === 'compact' && 'hidden'
					)}>
						{item.label}
					</p>
				);

			if (item.children) {
				return (
					<SobaVerticalNavExpansionPanel mode={mode} item={item} key={index}>
						{renderLevels(item.children)}
					</SobaVerticalNavExpansionPanel>
				);
			} 

			const content = (
				<div className={cn(
					"flex items-center w-full h-11 px-4 py-2 mb-2 rounded-md transition-all duration-150 hover:bg-white/10 group overflow-hidden whitespace-nowrap",
					mode === 'compact' && "px-2 justify-center"
				)}>
					{item?.icon ? (
						<LucideIcon 
							name={item.icon} 
							className="shrink-0 text-white/70 group-hover:text-white" 
						/>
					) : (
						<Fragment>
							<div className={cn(
								"w-1 h-1 rounded-full bg-white/70 ml-5 mr-3 shrink-0 nav-bullet",
								mode === 'compact' && 'hidden'
							)} />
							{mode === 'compact' && (
								<span className="text-[11px] font-bold text-white/70 group-hover:text-white">
									{item.iconText}
								</span>
							)}
						</Fragment>
					)}
					<span className={cn(
						"text-sm font-medium text-white/70 group-hover:text-white pl-3 transition-opacity duration-300",
						mode === 'compact' && "opacity-0 invisible w-0"
					)}>
						{item.name}
					</span>

					<div className="flex-grow" />

					{item.badge && (
						<div className={cn(
							"px-2 py-0.5 rounded-full bg-primary-foreground text-primary text-[10px] font-bold",
							mode === 'compact' && "hidden"
						)}>
							{item.badge.value}
						</div>
					)}
				</div>
			);

			if (item.type === 'extLink') {
				return (
					<a
						key={index}
						href={item.path}
						rel="noopener noreferrer"
						target="_blank"
						className="block text-white no-underline"
					>
						{content}
					</a>
				);
			} else {
				return (
					<NavLink
						key={index}
						to={item.path}
						className={({ isActive }) =>
							cn(
								"block text-white no-underline",
								isActive && "[&>div]:bg-white/20 [&>div]:text-white [&>div>span]:text-white [&>div>svg]:text-white"
							)
						}
					>
						{content}
					</NavLink>
				);
			}
		});
	};

	let navItems;

	if (authRoles.admin.includes(authenticatedPartner.role)) {
		const { adminNavigations } = items;
		navItems = adminNavigations;
	} else if (authRoles.staff.includes(authenticatedPartner.role)) {
		const { staffNavigations } = items;
		navItems = staffNavigations;
	} else {
		navItems = null;
	}

	return <div className="navigation">{renderLevels(navItems)}</div>;
};

export default React.memo(SobaVerticalNav);

